import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getDualColumnSectionStyles = () => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    sectionContainerStyle: {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between'
    },
    container: {
      flex: 1
    },
    topHalfContainerDefaultStyle: {
      paddingBottom: spacing.SPACING_10,
      paddingHorizontal: spacing.SPACING_5
    },
    bottomHalfContainerDefaultStyle: {
      paddingTop: spacing.SPACING_10,
      paddingHorizontal: spacing.SPACING_5
    },
    fullSizeColumnStyle: {
      paddingHorizontal: spacing.SPACING_5
    }
  });
};